import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../utils/parseError.js';


const createTourPreReq = async ({ state, userId, createTourPreReq, updateState, addResourceDayType, editResourceDayType, Toast }) => {
  const resourceId = state.resource.id;
  const { itemDetails } = state;
  const { dayTypeId, tourStartTime } = itemDetails;
  const date = tourStartTime.format('YYYYMMDD');
  const { resourceDayType } = createTourPreReq;
  // check if a resourceDayType currently exists and if not,
  // create day type
  if (resourceDayType.data.length === 0) {
    console.log('No resourceDayType exists, creating one...');
    const parameters = {
      date,
      dayTypeId,
      resourceId,
      comment: null,
      myComment: null,
      TKComment: null,
      userId
    };

    // store dayType parameters for optimistic re-render
    itemDetails.dayTypeParams = parameters;
    await updateState({
      itemDetails,
      crudLoading: true // prevents page refresh on addResourceDayType complete
    });
    // add new resource day type
    const { resource } = state;
    const { tourStartTime } = state.itemDetails;
    const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Resource Day Type Added', description: `For ${resource.name} on ${day}`};
    try {
      await addResourceDayType(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        console.log(error);
        notification = {
          type: 'error',
          message: "Adding Resource Day Type Error",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
      }
    }
    Toast(notification); // send notification no matter what
  }

  // check if current dayType conflicts with form submission and if so,
  // update dayType
  if (resourceDayType.data[0] && resourceDayType.data[0].dayTypeId !== dayTypeId) {
    console.log('Existing dayType conflict, resolving...');
    const parameters = {
      date,
      dayTypeId, // the one chosen on form
      resourceId: parseInt(resourceId),
      approved: resourceDayType.data[0].approved,
      comment: resourceDayType.data[0].comment || ' ',
      myComment: resourceDayType.data[0].myComment || ' ',
      daysRequestId: resourceDayType.data[0].daysRequestId,
      userId,
      unionId: resourceDayType.data[0].unionId,
      contractId: resourceDayType.data[0].contractId,
      contractRulesGroupId: resourceDayType.data[0].contractRulesGroupId,
      salaryLevelId: resourceDayType.data[0].salaryLevelId,
      TKComment: resourceDayType.data[0].TKComment || ' ',
      jobSalaryId: resourceDayType.data[0].jobSalaryId,
      hourlyActivityRateFlag: resourceDayType.data[0].hourlyActivityRateFlag,
      rate: resourceDayType.data[0].rate,
      resourceDayTypeId: resourceDayType.data[0].resourceDayTypeId
    };

    // store dayType parameters for optimistic re-ender
    itemDetails.dayTypeParams = parameters;
    await updateState({
      itemDetails,
      crudLoading: true // prevents page refresh on editResourceDayType complete
    });
    // edit existing resource day type (everything but dayTypeId and userId a.k.a. updatingUserId stayed the same)
    const { resource } = state;
    const { tourStartTime } = state.itemDetails;
    const day = moment(tourStartTime).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Resource Day Type Updated', description: `For ${resource.name} on ${day}`};
    try {
      await editResourceDayType(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'editResourceDayType',
            message: parseError(error)
          }
        });
        console.log(error);
          notification = {
            type: 'error',
            message: "Updating Resource Day Type Failed",
            description: `For [${resource.name} on ${day}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    // no need to refresh here, createTour will handle this
  }
  return createTourPreReq;
}

export default createTourPreReq;
